import ValidationStrings from "@strings/ValidationHelper.json";

type ValidationValue = string | null | undefined;

/**
 * Validates a "confirm password" field against the original password.
 * @param password - The original password to match against
 * @param confirmPassword - The value entered in the confirm-password field
 */
export function validateConfirmPassword(
  password: ValidationValue,
  confirmPassword: ValidationValue,
): string | undefined {
  let error;
  if (!confirmPassword) {
    error = ValidationStrings.passwordRequired;
  } else if (confirmPassword !== password) {
    error = ValidationStrings.passwordsDoNotMatch;
  }

  return error;
}

/**
 * Validates that a value is present and looks like an email address.
 * @param value - The field value to validate
 */
export function validateEmail(value: ValidationValue): string | undefined {
  let error;
  if (!value) {
    error = ValidationStrings.emailRequired;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = ValidationStrings.emailInvalid;
  }
  return error;
}

/**
 * Validates that a message field is present.
 * @param value - The field value to validate
 */
export function validateMessage(value: ValidationValue): string | undefined {
  let error;
  if (!value) {
    error = ValidationStrings.messageRequired;
  }
  return error;
}

/**
 * Validates that a name field is present.
 * @param value - The field value to validate
 */
export function validateName(value: ValidationValue): string | undefined {
  let error;
  if (!value) {
    error = ValidationStrings.nameRequired;
  }
  return error;
}

/**
 * Validates that a password field is present.
 * @param value - The field value to validate
 */
export function validatePassword(value: ValidationValue): string | undefined {
  let error;
  if (!value) {
    error = ValidationStrings.passwordRequired;
  }
  return error;
}

/**
 * Validates that a subject field is present.
 * @param value - The field value to validate
 */
export function validateSubject(value: ValidationValue): string | undefined {
  let error;
  if (!value) {
    error = ValidationStrings.subjectRequired;
  }
  return error;
}

/**
 * Validates that a help request priority has been chosen.
 * @param value - The selected priority level as a string ("" when none is chosen)
 */
export function validatePriority(value: ValidationValue): string | undefined {
  let error;
  if (!value) {
    error = ValidationStrings.priorityRequired;
  }
  return error;
}

/**
 * Validates that a generic required text field is present.
 * @param value - The field value to validate
 */
export function validateTextField(value: ValidationValue): string | undefined {
  let error;
  if (!value) {
    error = ValidationStrings.required;
  }
  return error;
}
